import { Pipe, PipeTransform } from '@angular/core';
import { PersonProfileService } from 'src/app/people/profile/person-profile.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Pipe({ name: 'evaluationTeamRatingsPipe' })
export class EvaluationTeamRatingsPipe implements PipeTransform {
  constructor(private personProfileService: PersonProfileService) {}

  transform(teamId: string, prop: string): Observable<any> {
    return this.personProfileService.personEvaluationSummary.pipe(
      map((result) => {
        if (result) {
          let teamRatings = result.filter((x) => x.teamId == teamId);
          if (prop == 'averageTeamRatings') {
            let averageTeamRatings =
              teamRatings
                .filter((x) => x.rating > 0)
                .reduce((total, next) => {
                  return total + next.rating;
                }, 0) / teamRatings.filter((x) => x.rating > 0).length;
            return averageTeamRatings ? Math.round(averageTeamRatings * 100) / 100 : 'N/A';
          }
          if (prop == 'averageTeamRatingsCount') {
            return teamRatings.length;
          }
          if (prop == 'hasEvaluation') return teamRatings.length > 0;
        }
      })
    );
  }
}
